import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { LoadingService } from '../../core/services/loading.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { HelpersService } from '../../core/services/helpers.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  form: FormGroup;

  constructor(
    private authService: AuthService,
    private loadingService: LoadingService,
    private fb: FormBuilder,
    private helpers: HelpersService,
    private router: Router
  ) {
    this.form = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }

  login() {
    this.form.markAllAsTouched();
    if (!this.form.valid) return;

    this.loadingService.startLoading();
    this.authService
      .auth(this.form.value)
      .then((res) => {
        this.authService.setJwtToken(res.data?.jwt);
        this.authService.setUser(JSON.stringify(res.data?.userData));
        this.loadingService.endLoading();
        this.helpers.sbSuccess('Login Berhasil!');
        this.router.navigate(['/dashboard']);
      })
      .catch((error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      });
  }
}
